import type { RouteRecordRaw } from 'vue-router'

export const routeName = 'NotFoundPage'

export const route: RouteRecordRaw = {
  path: '/:pathMatch(.*)*',
  name: routeName,
  component: () => import('@/pages/notFound/NotFoundPage.vue'),
  meta: { title: 'PageNotFound', requiresAuth: false },
}
